import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postForgotPassword } from "../../services/api";
import { useTranslation } from "react-i18next";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submit edildi, email:", email);

    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      console.log("API çağrısı başlıyor...");
      console.log(email, "email");
      const response = await postForgotPassword(email);
      console.log("API başarılı response:", response);

      navigate(`/forgot-password-confirm?email=${encodeURIComponent(email)}`);
    } catch (err) {
      console.log("Hata yakalandı:", err);
      console.log("Hata detayları:", {
        message: err.message,
        response: err.response,
        status: err?.response?.status,
        data: err?.response?.data,
      });

      const msg = err?.response?.data?.message || err.message || "";
      console.log("İşlenmiş hata mesajı:", msg);

      if (
        err?.response?.status === 400 ||
        err?.response?.status === 404 ||
        (typeof msg === "string" &&
          (msg.toLowerCase().includes("kullanıcı") ||
            msg.toLowerCase().includes("user") ||
            msg.toLowerCase().includes("email") ||
            msg.toLowerCase().includes("bulunamadı") ||
            msg.toLowerCase().includes("not found")))
      ) {
        console.log("Kullanıcı bulunamadı hatası");
        setError(t("userNotFoundError"));
      } else {
        console.log("Genel hata durumu");
        setError(msg || t("generalError"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    console.log("Email değişti:", newEmail);
    setEmail(newEmail);
  };

  return (
    <div className="h-screen flex bg-white">
      {/* Sol taraf - Form Container */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white  p-6">
          <Link to="/login" className="flex items-center justify-center ">
            <img
              src="/assets/qriendLogoRedNew.png"
              alt="QRiend Logo"
              className="w-56 h-28"
            />
          </Link>

          <h2 className="text-2xl font-semibold font-poppins text-center text-[#222] mb-2">
            {t("resetPassword")}
          </h2>
          <p className="text-center text-gray-500 text-sm mb-6">
            {t("resetPasswordDesc")}
          </p>
          <form onSubmit={handleSubmit}>
            <input
              id="email"
              type="email"
              required
              placeholder={t("emailPlaceholder")}
              className="bg-white text-black w-full px-4 py-2 border border-gray-300 rounded-lg mb-6 focus:outline-none focus:ring-2 focus:ring-pink-400"
              value={email}
              onChange={handleEmailChange}
              disabled={isLoading}
            />
            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-2 rounded-full text-white font-semibold text-lg bg-gradient-to-r from-[#FA3091] to-[#E94057] shadow-md hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? t("sending") : t("send")}
            </button>
            {error && (
              <div className="text-red-500 text-sm text-center mt-4">
                {error}
              </div>
            )}
            {success && (
              <div className="text-green-600 text-sm text-center mt-4">
                {success}
              </div>
            )}
            <h2 className="text-gray-400 text-sm md:text-md flex justify-center pt-4">
              {t("checkSpamFolder")}
            </h2>
          </form>
        </div>
      </div>

      {/* Sağ taraf - Görsel */}
      <div className="hidden lg:flex lg:w-1/2  items-center justify-center p-8">
        <img
          src="/assets/forgotPassImg.png"
          alt={t("resetPassword")}
          className="w-full h-full object-contain"
          onError={(e) => {
            // Eğer bu görsel yoksa alternatif görseli kullan
            e.target.src = "/assets/loginPageImage.png";
          }}
        />
      </div>
    </div>
  );
}
